export default __webpack_public_path__ + "static/media/explore_destination_img8.743fe9e9.jpg";